import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const unassignEmptyBinProducts = {
  name: "unassignEmptyBinProducts" as const,
  input: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1).max(500),
  }),
  output: z.object({ unassigned: z.number(), kept: z.number() }),
};
